import { lastOrNull1aq5oz189qoe1 as lastOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { removeLast3759euu1xvfa3 as removeLast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import {
  CLASS_getInstance14ex35co4jkrb as CLASS_getInstance,
  SEALED_getInstance3nsev85ow9059 as SEALED_getInstance,
  OPEN_getInstance3ec6az8uwus55 as OPEN_getInstance,
  LIST_getInstancey7k5h8d5cvxt as LIST_getInstance,
  MAP_getInstance3s1t6byguxmp9 as MAP_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { Char19o2r8palgjof as Char } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { StringCompanionObject_instance3alxothmy382k as StringCompanionObject_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { serializer1x79l67jvwntn as serializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  beginCollection27i47rk9upjw4 as beginCollection,
  encodeNullableSerializableValue22qo2euy9x1r4 as encodeNullableSerializableValue,
  shouldEncodeElementDefault1vy568gzcy4z0 as shouldEncodeElementDefault,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/Encoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function encodeElement($this, desc, index) {
  var tag = $this.u1h(desc, index);
  pushTag($this, tag);
  return true;
}
function _get_currentTagOrNull__k1dbj4($this) {
  return lastOrNull($this.ser_1);
}
function pushTag($this, name) {
  $this.ser_1.v(name);
}
function popTag($this) {
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!$this.ser_1.i1()) {
    tmp = $this.ser_1.z3(get_lastIndex($this.ser_1));
  } else {
    tmp = 'value';
  }
  return tmp;
}
function nested($this, nestedName) {
  var tmp0_elvis_lhs = _get_currentTagOrNull__k1dbj4($this);
  return $this.a1i(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
}
var StringDeferringEncoderClass;
function StringDeferringEncoder() {
  if (StringDeferringEncoderClass === VOID) {
    class $ {
      constructor(config, steadyHeaders) {
        steadyHeaders = steadyHeaders === VOID ? true : steadyHeaders;
        this.oer_1 = config;
        this.per_1 = steadyHeaders;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.qer_1 = LinkedHashMap().f6();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp_0.rer_1 = ArrayList().w();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp_1.ser_1 = ArrayList().w();
      }
      mz() {
        return this.oer_1.wer_1;
      }
      n4z(value) {
        return toString(value);
      }
      nz(serializer, value) {
        var tmp0_subject = serializer.az().s11();
        if (equals(tmp0_subject, SEALED_getInstance()) || equals(tmp0_subject, OPEN_getInstance()) || (equals(tmp0_subject, LIST_getInstance()) || equals(tmp0_subject, MAP_getInstance()))) {
          if (this.per_1) {
            this.o4z(popTag(this), this.oer_1.zer_1 + this.oer_1.aes_1.x27(serializer, value));
          } else {
            serializer.oz(this, value);
          }
        } else if (equals(tmp0_subject, CLASS_getInstance()))
          if (this.per_1 && this.rer_1.t1(serializer.az().h10())) {
            this.o4z(popTag(this), this.oer_1.zer_1 + this.oer_1.aes_1.x27(serializer, value));
          } else {
            this.rer_1.v(serializer.az().h10());
            serializer.oz(this, value);
            removeLast(this.rer_1);
          }
         else {
          serializer.oz(this, value);
        }
      }
      o4z(tag, value) {
        var tmp0 = this.qer_1;
        // Inline function 'kotlin.collections.set' call
        var value_0 = this.n4z(value);
        tmp0.s3(tag, value_0);
      }
      p4z(tag) {
        var tmp0 = this.qer_1;
        // Inline function 'kotlin.collections.set' call
        var value = this.oer_1.yer_1;
        tmp0.s3(tag, value);
      }
      q4z(tag, enumDescriptor, ordinal) {
        var tmp0 = this.qer_1;
        // Inline function 'kotlin.collections.set' call
        var value = this.n4z(enumDescriptor.v11(ordinal));
        tmp0.s3(tag, value);
      }
      fes() {
      }
      ges(tag, value) {
        return this.o4z(tag, value);
      }
      hes(tag, value) {
        return this.o4z(tag, value);
      }
      ies(tag, value) {
        return this.o4z(tag, value);
      }
      jes(tag, value) {
        return this.o4z(tag, value);
      }
      kes(tag, value) {
        return this.o4z(tag, value);
      }
      les(tag, value) {
        return this.o4z(tag, value);
      }
      mes(tag, value) {
        return this.o4z(tag, value);
      }
      nes(tag, value) {
        return this.o4z(tag, new (Char())(value));
      }
      oes(tag, value) {
        return this.o4z(tag, startsWith(value, this.oer_1.zer_1) ? this.oer_1.zer_1 + this.oer_1.aes_1.x27(serializer(StringCompanionObject_instance), value) : value);
      }
      pes(tag) {
        // Inline function 'kotlin.apply' call
        pushTag(this, tag);
        return this;
      }
      r14(descriptor) {
        return this.pes(popTag(this));
      }
      f15() {
        return this.fes();
      }
      g14() {
        return this.p4z(popTag(this));
      }
      h14(value) {
        return this.mes(popTag(this), value);
      }
      i14(value) {
        return this.hes(popTag(this), value);
      }
      j14(value) {
        return this.ies(popTag(this), value);
      }
      k14(value) {
        return this.ges(popTag(this), value);
      }
      l14(value) {
        return this.jes(popTag(this), value);
      }
      m14(value) {
        return this.kes(popTag(this), value);
      }
      n14(value) {
        return this.les(popTag(this), value);
      }
      o14(value) {
        return this.nes(popTag(this), value);
      }
      p14(value) {
        return this.oes(popTag(this), value);
      }
      q14(enumDescriptor, index) {
        return this.q4z(popTag(this), enumDescriptor, index);
      }
      l13(descriptor) {
        return this;
      }
      m13(descriptor) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.ser_1.i1()) {
          popTag(this);
        }
      }
      s14(descriptor, index, value) {
        return this.mes(this.u1h(descriptor, index), value);
      }
      t14(descriptor, index, value) {
        return this.hes(this.u1h(descriptor, index), value);
      }
      u14(descriptor, index, value) {
        return this.ies(this.u1h(descriptor, index), value);
      }
      v14(descriptor, index, value) {
        return this.ges(this.u1h(descriptor, index), value);
      }
      w14(descriptor, index, value) {
        return this.jes(this.u1h(descriptor, index), value);
      }
      x14(descriptor, index, value) {
        return this.kes(this.u1h(descriptor, index), value);
      }
      y14(descriptor, index, value) {
        return this.les(this.u1h(descriptor, index), value);
      }
      z14(descriptor, index, value) {
        return this.nes(this.u1h(descriptor, index), value);
      }
      a15(descriptor, index, value) {
        return this.oes(this.u1h(descriptor, index), value);
      }
      b15(descriptor, index) {
        return this.pes(this.u1h(descriptor, index));
      }
      c15(descriptor, index, serializer, value) {
        if (encodeElement(this, descriptor, index)) {
          this.nz(serializer, value);
        }
      }
      d15(descriptor, index, serializer, value) {
        if (encodeElement(this, descriptor, index)) {
          this.e15(serializer, value);
        }
      }
      u1h(_this__u8e3s4, index) {
        return nested(this, this.v1h(_this__u8e3s4, index));
      }
      v1h(descriptor, index) {
        return descriptor.v11(index);
      }
      a1i(parentName, childName) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(parentName) === 0) {
          tmp = childName;
        } else {
          tmp = parentName + '.' + childName;
        }
        return tmp;
      }
    }
    protoOf($).g15 = beginCollection;
    protoOf($).e15 = encodeNullableSerializableValue;
    protoOf($).h15 = shouldEncodeElementDefault;
    initMetadataForClass($, 'StringDeferringEncoder', VOID, VOID, [Encoder(), CompositeEncoder()]);
    StringDeferringEncoderClass = $;
  }
  return StringDeferringEncoderClass;
}
//region block: exports
export {
  StringDeferringEncoder as StringDeferringEncoder2g68f2tkdfmtv,
};
//endregion

//# sourceMappingURL=StringDeferringEncoder.mjs.map
